const CARGA = () => import('../views/CargaSistema.vue')
const MGSYS = () => import('../views/MigracoesSistemas.vue')

export default [
  { name: 'viewCarga', path: '/manutencao/cargas-do-sistema', component: CARGA },
  { name: 'viewMgSys', path: '/manutencao/migracoes-de-sistemas', component: MGSYS }
  //  { name: 'viewTda', path: '/transparencia/tabela-das-diarias', component: TDA, meta: { acl: true } },
]
